<template>
  <ais-instant-search
    :search-client="searchClient"
    :index-name="indexName"
    :routing="urlSync ? instantSearchRouting : null"
  >
  <CustomConfigure :hitsPerPage="hitsPerPage" :parameters="searchParameters">
    <slot></slot>
  </CustomConfigure>
  </ais-instant-search>
</template>

<script>
import algoliasearch from 'algoliasearch/lite'
import CustomConfigure from '@/components/general/CustomConfigure.vue'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'AlgoliaSearchWrapper',
  components: {
    CustomConfigure
  },
  props: {
    indexName: String,
    urlSync: {
      type: Boolean,
      default: false
    },
    searchParameters: { type: Object, default: () => {} },
    hitsPerPage: { type: Number, default: 20 },
    forRoute: String
  },
  data () {
    return {
      searchClient: process.env.VUE_APP_ALGOLIASECUREDSEARCH_ENABLE ? this.$AlgoliaSecuredSearchGetKeyPerIndex(this.indexName) : algoliasearch(
        '9N5LGLZPRT',
        'e5b8a01d8c6ca064424f71e630360d15'
      ) // Remove env variable to enable algolia secured search mechanism

    }
  },
  computed: {
    ...mapState(['generalApp']),
    instantSearchRouting () {
      const self = this
      // const routerInstance = this.$router
      return {
        router: {
          read () {
            return self.$router.currentRoute.query
          },
          write (routeState, selectedDateFilters = self.dateFilterForUrl) {
            if (self.$router.currentRoute.name === self.forRoute) {
              if (selectedDateFilters.length > 0) {
                routeState['dateFilters'] = selectedDateFilters
              }
              self.$router.push({
                query: routeState
              })
            }
          },
          createURL (routeState) {
            return self.$router.resolve({
              query: routeState
            }).href
          },
          onUpdate () {},
          dispose () {}
        },
        stateMapping: {
          stateToRoute (uiState) {
            let entries = Object.entries(uiState).map(([widgetName, value]) => {
              if (typeof value === 'object') {
                let joined = []
                Object.entries(value).forEach(el => {
                  if (Array.isArray(el[1])) {
                    joined.push(el[0] + '~' + el[1].join('~'))
                  } else {
                    joined.push(el[0] + '~' + el[1])
                  }
                })
                return [widgetName, joined]
              }
              return [widgetName, value]
            })
            let urlValues = Object.fromEntries(
              entries
            )
            return urlValues
          },
          routeToState (routeState, setDateFilter = self.setDateFilter) {
            let entries = Object.entries(routeState).map(([widgetName, value]) => {
              if (typeof value === 'object') {
                let filters = {}
                value.forEach(el => {
                  const [attribute, ...values] = el.split('~')
                  filters[attribute] = values
                })
                let testState = [
                  widgetName, filters
                ]
                return testState
              }
              if (value.includes('~')) {
                let [attribute, ...values] = value.split('~')
                if (widgetName === 'range') {
                  values = values[0]
                }
                return [widgetName, { [attribute]: values }]
              }
              return [widgetName, value]
            })
            let state = Object.fromEntries(
              entries
            )
            if (state.dateFilters !== undefined) {
              Object.keys(state.dateFilters).forEach(function (item) {
                const index = state.dateFilters[item][0]
                const dateFilter = item + ':' + state.dateFilters[item][1].replace('-', ' TO ')
                setDateFilter({ filter: dateFilter, index: index })
              })
            }
            return state
          }
        }
      }
    },
    dateFilterForUrl () {
      let filters = this.generalApp.algoliaDateFilters
      let filtersUrl = []
      Object.keys(filters).forEach(item => {
        let parts = filters[item].split(':')
        filtersUrl.push([parts[0] + '~' + item + '~' + parts[1].replace(' TO ', '-')])
      })

      return filtersUrl
    }
  },
  methods: {
    ...mapActions({
      setDateFilter: 'setDateFilter'
    })
  }
}
</script>
